<div id="supplement-form" class="skv-box skv-box--compact" role="main">
    <h2>Komplettera din pågående ansökan</h2>
    <p>
      Här förklarar vi hur du kan komplettera din pågående ansökan om lärar- och förskollärarlegitimation eller pågående ansökan
      om att utöka med fler behörigheter. Det kan antingen vara att du har missat att bifoga handlingar eller har blivit ombedd
      att inkomma med kompletterande handlingar. Samtliga handlingar ska bifogas i PDF-format.
    </p>

  <p>
    Så här kompletterar du ditt ärende, beroende på när du ansökte:<br/></p>
  <ul>
    <li>Om du skickat in din ansökan innan 28 maj 2024 följ instruktionerna i formuläret nedan. </li>
    <li>Om du skickat din ansökan efter 29 maj 2024 kan du komplettera via vår <a target="blank"
                                                                                  href="https://lleg.skolverket.se/">
      <u>e-tjänst</u></a> </li>
  </ul>

  <p>
    Observera att du måste ha en pågående ansökan. En ny ansökan kan du göra <a target="blank"
                                                                                href="https://lleg.skolverket.se/">
    <u>här</u></a>
    </p>
    <app-reveal title="Hur bifogar du kompletteringen">
        <ul>
            <li><b>E-post: </b>Fyller du i för att vi ska kunna skicka en bekräftelse på att vi har mottagit
                handlingarna.</li>
            <li><b>Personnummer: </b>Här fyller du ditt personnummer för att vi ska kunna matcha dina handlingar med
                ditt ärende.</li>
            <li><b>Bifoga fil: </b>Här bifogar du dina handlingar. Observera att dina handlingar måste vara i
                PDF-format. Nedan kan du läsa mer om hur kan skapar PDF-filer.</li>
        </ul>
    </app-reveal>
    <app-reveal title="Så här gör du en PDF">
        Samtliga bilagor måste vara i formatet PDF. Observera att bara ändra filändelsen till ”.pdf” är inte korrekt
        sätt. Det finns lite olika sätt att skapa PDF och olika program som skapar PDF. Windows 10 har en inbyggd
        PDF-skrivare, så allt du kan skriva ut kan du välja att spara som en PDF-fil – i alla program. Här kan du läsa
        mer om det.
        <br />
        <app-link href="https://helpx.adobe.com/se/acrobat/using/print-to-pdf.html" [external]="true">
            https://helpx.adobe.com/se/acrobat/using/print-to-pdf.html
        </app-link>
    </app-reveal>
    <app-reveal title="Personuppgiftsbehandling inom lärar- och förskollärarregistret">
        <h3>Syfte med behandling av dina personuppgifter</h3>
        <p>
            Vi behandlar dina personuppgifter inom ditt ärende för att handlägga ansökan om legitimation. Vi behöver ha
            personuppgifter för att kunna kontakta dig, för att verifiera och styrka dina uppgifter samt kunna göra
            korrekta
            bedömning av ditt ärende. Detta innebär att:
        </p>
        <ul>
            <li>Vi kommer att i ansökan inhämta uppgifter om hur vi kontaktar dig. Epost och telefonnummer samt vilket
                personnummer du har. Vi kommer även att be att få intyg och handlingar som styrker dina yrkanden.</li>
            <li>Vi kommer även att inhämta personuppgifter från folkbokföringen för att säkerställa identitet i
                handlingarna samt kompletterande kontaktuppgifter.</li>
            <li>Vi kommer även att inhämta personuppgifter från Ladok för att komplettera eller förtydliga inskickade
                handlingar och uppgifter.</li>
            <li>Vi kommer även att inhämta information från lärosäten för att komplettera eller förtydliga inskickade
                handlingar och uppgifter.</li>
        </ul>

        <h3>Vem är ansvarig för personuppgiftsbehandlingarna</h3>
        <p>
            Skolverket (org. nr. är 202100-4185) är personuppgiftsansvarig för behandlingen av dina personuppgifter.
            <br />
            <br />
            Skolverket
            <br />
            Box 4002
            <br />
            171 04 Solna
            <br />
            Upplysningstjänst och växel: 08-527 332 00
        </p>
        <h3>Grunden för Skolverket att behandla dina personuppgifter</h3>
        <p>
            Enligt § 16 i skollagen (2010:800) ska Statens skolverk efter ansökan meddela legitimation till en lärare
            eller
            förskollärare som har behörighetsgivande examen. Enligt förordning (2011:268) om lärar- och
            förskollärarregister
            § 5 får Statens Skolverk behandla personuppgifter om det är nödvändigt för att föra en aktuell förteckning
            över
            legitimerade lärare och förskollärare. Utöver detta får Statens Skolverket även behandla personuppgifter
            enligt
            § 6 för att:
        </p>
        <ul>
            <li>Handlägga ärenden om legitimation.</li>
            <li>Lämna uppgifter till utländska myndigheter i enlighet med förordningen (2016:157) om erkännande av
                yrkeskvalifikationer.</li>
            <li>Utöva tillsyn av skolväsendet och dess personal.</li>
            <li>Kontrollera identitet och behörighet i samband med tjänstetillsättning av lärare och förskollärare.</li>
        </ul>
        <p>
            Personuppgiftsbehandlingen utförs för att Skolverket genom dessa författningar fått i uppdrag att fullgöra
            dessa
            uppgifter. Skolverkets behandling av personuppgifter utförs på den rättsliga grunden att det är nödvändigt
            för
            att utföra dessa myndighetsuppgifter och därigenom utföra en uppgift av allmänt intresse.
        </p>

        <h3>Eventuella mottagare av personuppgifter</h3>
        <p>
            Skolverket kommer i följande fall att skicka personuppgifter till externa mottagare.
        </p>
        <ul style="list-style: decimal;">
            <li>Vid bedömningen av ärenden med utländska examina kommer Skolverket att skicka personuppgifter till
                Universitets- och högskolerådet (UHR) för bedömning av utländska examina.</li>
            <li>Skolverket kommer att anlita en extern bedömare för att kunna handlägga ärenden med yrkesämnen. Vi
                kommer skriva ett avtal med den externa bedömaren så att dina personuppgifter hanteras i enlighet med
                lag hos dem.</li>
        </ul>
        <p>
            Uppgifter som betraktas som allmän handling kan också komma att lämnas ut i enlighet med
            offentlighetsprincipen
            om det inte bedöms råda sekretess för dem.
        </p>

        <h3>Överföring av uppgifter till tredje land</h3>
        <p>Skolverket överför inte uppgifter till tredjeland till eller till någon internationell organisation.</p>

        <h3>Hur länge sparas uppgifterna?</h3>
        <p>De personuppgifter som vi hämtat in om dig kommer att bevaras i ditt ärende som i sin tur återfinns vårt
            diarium och tillika ärendehanteringssystem. Detta för att de utgör allmänna handlingar hos Skolverket kommer
            att bevara de enlighet med arkivlagen (1990:782).</p>
        <h3>Dina rättigheter</h3>
        <p>
            Du har från Skolverket begära tillgång till (Artikel 15 GDPR) och rättelse av dina personuppgifter som är
            under behandling (Artikel 16 GDPR). Detta gör du genom hemsidan:
            <br />
            <a target="blank"
            href="https://www.skolverket.se/om-oss/begara-registerutdrag-med-personuppgifter">
            https://www.skolverket.se/om-oss/begara-registerutdrag-med-personuppgifter</a>
        </p>
        <p>
            Enligt registerförordning (2011:268) § 3 gäller inte Artikel 21. 1 i EU dataskyddsförordningen för sådan
            behandling av personuppgifter som förordning (2011:268) tillåter. Detta betyder har inte rätt att invända
            mot
            behandlingen eller begära begränsning av behandling av uppgifter som rör dig grundat på artikel 6.1 E eller
            F.
            Du har däremot rätt att invända att dina personuppgifter används för direkt marknadsföring och kan därför
            kontakta Skolverket för att säkerställa denna rätt.
            Skolverkets dataskyddsombud nås via <a
                href="mailTo:dataskyddsombudet@skolverket.se">dataskyddsombudet&#64;skolverket.se</a>
        </p>

        <h3>Utdrag från lärar- och förskollärarregistret</h3>
        <p>
            Alla lärare och förskollärare som har fått legitimation finns i lärar- och förskollärarregistret.
            Informationen är allmän handling och vem som helst har rätt att begära utdrag ur registret. Det är från
            detta register som utdrag görs för att bland annat uppfylla behovet av att kontrollera behörighet och utöva
            tillsyn av skolväsendet.
            <br />
            Utdrag från lärar- och förskollärarregistret gör på: lleg.registerutdrag&#64;skolverket.se
            <br />
            Klagomål till Integritetsskyddsmyndigheten
            <br />
            Om du anser att Skolverket har behandlat dina personuppgifter i strid med Dataskyddsförordningen eller den
            svenska dataskyddslagen har du också rätt att vända dig till Integritetsskyddsmyndigheten (IMY)för att klaga
            på det.
            <br />
            Datainspektionen nås via <a href="mailTo:imy@imy.se">imy&#64;imy.se</a>
        </p>

        <h3>Om EU:s dataskyddsförordning (GDPR)</h3>
        <p>
            EU:s dataskyddsförordning (GDPR) är det grundläggande regelverket för behandling av personuppgifter. Därtill
            finns kompletterande bestämmelser i svenska lagar och andra författningar. Utöver dataskyddsförordningen
            (GDPR) finns regler i nationell lagstiftning som gäller för viss personuppgiftsbehandling.
            <br />
            Inom lärar- och förskollärarregistret finns det bestämmelser om personuppgiftsbehandling i Förordning
            (2011:268) om lärar- och förskollärarregister.
            <br />
            I dataskyddsförordningen finns ett antal grundläggande principer som gäller för all personuppgiftsbehandling
            och som personuppgiftsansvariga behöver tänka på.
        </p>
        <ul>
            <li>Laglighet, korrekthet och öppenhet</li>
            <li>Ändamålsbegränsning</li>
            <li>Uppgiftsminimering</li>
            <li>Riktighet</li>
            <li>Lagringsminimering</li>
            <li>Integritet och konfidentialitet</li>
            <li>Ansvarsskyldighet</li>
        </ul>
        <p>
            All personuppgiftsbehandling måste ha stöd i dataskyddsförordningen.
        </p>
    </app-reveal>
    <app-form-group>
        <div>
            <app-input [control]="email" data-test-id="email">Epostadress</app-input>
            <app-input [control]="applicantSsn" data-test-id="applicantSsn">Personnummer</app-input>
        </div>
        <app-area [control]="applicantText" data-test-id="applicantText" maxLength="2000">Övrig information</app-area>
      <p>
        Maximalt antal tillåtna tecken är 2000. Om du har fler synpunkter går det bra att skicka in formuläret på nytt alternativt ladda upp ett längre yttrande som bilaga i PDF-format.
      </p>
    </app-form-group>

    <app-form-group>
        <app-attachment-selector [isSupplement]="true"></app-attachment-selector>
        <span *ngIf="attachmentsInvalid" class="error-text">Minst en bilaga måste vara bifogad.</span>
    </app-form-group>

    <app-form-group>
        <span *ngIf="groupError" class="error-text">{{groupError}}</span>
    </app-form-group>

    <div class="parent">
        <div class="table-row">
            <div class="child-left">
                <button *ngIf="!isSubmitting; else loading" class="btn btn--primary" type="button"
                    (click)="onSubmit()">Skicka
                    in</button>
            </div>
            <div class="child-right">
                <button class="btn btn--secondary" type="button" (click)="routeToStart()">Avbryt</button>
            </div>
        </div>
    </div>

</div>
<app-banner *ngIf="isSubmitted" type="confirmation">Din komplettering har skickats in.</app-banner>
<app-banner *ngIf="hasError" type="error">Kunde inte skicka in din komplettering. Vänligen försök igen. Kontakta support
    om problemet kvarstår.</app-banner>
<ng-template #loading>
    <mat-spinner diameter="40"></mat-spinner>
</ng-template>
